import React from 'react';
import { View, type ViewProps, type ViewStyle } from 'react-native';
export function SkillGradient({ style, ...props }: ViewProps) {
  return (
    <View
      {...props}
      style={[
        { backgroundColor: '#63365e' },
        style,
        {
          backgroundImage: 'linear-gradient(145deg, #39335f 0%, #91475e 52%, #ae7649 100%)',
        } as ViewStyle,
      ]}
    />
  );
}
